import * as moment from 'moment-timezone';
export var isDateBefore = function (firstDate, secondDate) {
    return moment(firstDate).isBefore(secondDate);
};
export var isDateSameOrBefore = function (firstDate, secondDate) {
    return moment(firstDate).isSameOrBefore(secondDate);
};
export var isValidTimeFormat = function (time, format) {
    var currentInput = moment(time, format, true);
    return currentInput.isValid();
};
export var getStartOfDay = function (time, timeFormat, outputFormat) {
    return moment(time, timeFormat).startOf('day').format(outputFormat);
};
export var getEndOfDay = function (time, timeFormat, outputFormat) {
    return moment(time, timeFormat).endOf('day').format(outputFormat);
};
export var isStartOfDayBeforeNow = function (time, format) {
    return moment(time, format).startOf('day').isBefore(moment());
};
export var isEndOfDayBeforeNow = function (time, format) {
    return moment(time, format).endOf('day').isBefore(moment());
};
export var formatDate = function (date, outputFormat) {
    if (outputFormat === void 0) { outputFormat = 'MM/DD/YYYY'; }
    return moment(date).format(outputFormat);
};
export var formatDateToObject = function (date, format) {
    if (format === void 0) { format = 'MM/DD/YYYY'; }
    var formattedDate = moment(date, format);
    return {
        year: formattedDate.year(),
        month: formattedDate.month() + 1,
        day: formattedDate.date(),
    };
};
var formatTime = function (time, timeFormat, outputFormat) {
    if (timeFormat === void 0) { timeFormat = 'HH:mm'; }
    if (outputFormat === void 0) { outputFormat = 'h:mm A'; }
    return moment(time, timeFormat).format(outputFormat);
};
export default formatTime;
